module.exports = __webpack_public_path__ + "static/media/1.69a1428b.png";